import { Record } from "immutable";

const DescriptionRecord = Record({
  termStart: "",
  termEnd: "",
  numbers: null,
  answerRate: 0,
  method: "",
  note: "",
  answers: []
});

class Description extends DescriptionRecord {}

export default Description;



// WEBPACK FOOTER //
// ./src/models/Description.js